import {EntityWithIdAndDescription} from "../../types/baseEntities";
import {HttpAxiosRequest} from "../httpAxiosBase";
import {
    FileBase,
    FileBaseFields,
    SolicitationFileViewDTO
} from "../../types/solicitation/solicitationFile";
import {
    SolicitationFileRequestedView
} from "../../types/solicitation/solicitationData";

export const HttpSolicitationFiles = {
    getEndpoint: (solicitationId: number, url = ''): string => `solicitud/${solicitationId}/archivo${url}`,
    
    getFileList : (solicitationId: number) : Promise<SolicitationFileViewDTO[]> => {
      return HttpAxiosRequest.get(
          HttpSolicitationFiles.getEndpoint(solicitationId)
      )  
    },
    
    getMandatory : (solicitationId: number) : Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(
            HttpSolicitationFiles.getEndpoint(solicitationId, '/obligatorios')
        )
    },
    
    insert: (solicitationId: number, fileSolicitation: FileBase, file: File) : Promise<number> => {
        const formData : FormData = new FormData();

        formData.append("codArchivoTipo", fileSolicitation.codArchivoTipo.toString());
        formData.append("tieneArchivoFisico", 'false');
        formData.append("descArchivo", fileSolicitation.descArchivo);
        formData.append("observacion", fileSolicitation[FileBaseFields.Observation])
        formData.append("idSolicitudOperacion", '');
        formData.append("file", file, fileSolicitation.descArchivo);

        return HttpAxiosRequest.post(
            HttpSolicitationFiles.getEndpoint(solicitationId),
            formData
        );
    },
    
    getRequestedDocs: (solicitationId: number, solicitationRequestedDocId: number) : Promise<SolicitationFileRequestedView[]> => {
        return HttpAxiosRequest.get(
            HttpSolicitationFiles.getEndpoint(solicitationId, `/pedido-documentacion/${solicitationRequestedDocId}`)
        )
    },
    
    insertRequestedDoc: 
        (solicitationId: number, solicitationRequestedDocId: number, fileSolicitation?: FileBase, file?: File, fileId?: number) 
            : Promise<number> => {
        const formData : FormData = new FormData();

        if (fileSolicitation && file) {
            formData.append("codArchivoTipo", fileSolicitation.codArchivoTipo.toString());
            formData.append("tieneArchivoFisico", 'false');
            formData.append("descArchivo", fileSolicitation.descArchivo);
            formData.append("observacion", fileSolicitation[FileBaseFields.Observation])
            formData.append("file", file, fileSolicitation.descArchivo);
        }else if (fileId) {
            formData.append("idArchivo", fileId.toString());
        }
        
        return HttpAxiosRequest.post(
            HttpSolicitationFiles.getEndpoint(solicitationId, `/pedido-documentacion/${solicitationRequestedDocId}`),
            formData
        )
    }
}